class AppErrorHandler {
  constructor(appLogger) {
    'inject';

    this._appLogger = appLogger;
  }
  handle(error, customMessage = '', silent = false) {
    if (!silent) {
      const message = customMessage || error.message || 'Unexpected error';
      this._appLogger.error(message);
    }

    if (error instanceof Error) {
      this._appLogger.error(error);
    }
  }
  silent(error) {
    return this.handle(error, '', true);
  }
}

export { AppErrorHandler };
